import React from "react";

import { ReactComponent as GoogleMeetLogo } from "~/legacy-assets/images/logos/google_meet.svg";
import { ReactComponent as MSTeamsLogo } from "~/legacy-assets/images/logos/microsoft-teams-icon.svg";
import { ReactComponent as ZoomLogo } from "~/legacy-assets/images/logos/zoom_icon_only.svg";

import type { ConferenceOption, ConferenceProvider } from "../hooks/useConferencingOptions";

import styles from "./ConferenceSelector.module.css";

export const ConferenceIcons: Record<ConferenceProvider, React.FunctionComponent<React.SVGProps<SVGSVGElement>>> = {
	GOOGLE: GoogleMeetLogo,
	ZOOM: ZoomLogo,
	TEAMS: MSTeamsLogo,
	NONE: () => null,
};

export function conferenceOptionLabelCreator({ value, label, needsSetup }: ConferenceOption) {
	const ConferenceIcon = ConferenceIcons[value];
	return (
		<div>
			{value !== "NONE" && (
				<span className={styles.conferenceIconContainer}>
					<ConferenceIcon className={styles.conferenceIcon} />
				</span>
			)}
			{!needsSetup ? (
				label
			) : (
				<div className={styles.conferenceSelectorLabel}>
					<span>{label}</span>
					<small>Click to set up</small>
				</div>
			)}
		</div>
	);
}
